import { useGetAPIIntegrations } from 'modules/core/api/integrations/useGetAPIIntegrations';
import { useAPIGetCategories } from 'modules/core/api/mappings/useAPIGetCategories';

const SPECIAL_TABLE_CATEGORIES: Record<string, string> = {
    org_chart: 'org_chart',
    historical_org_chart_hr: 'historical_org_chart_hr',
};

const MAPPING_LABEL_KEYS: Record<string, string> = {
    org_chart: 'dataCatalog.viewUnifiedServices',
    historical_org_chart_hr: 'dataCatalog.viewUpdatedServices',
};

export const useMappingTarget = (
    mappingCategory: string | null,
    table: string,
) => {
    const { data: categories = [] } = useAPIGetCategories();
    const { data: integrations = [] } = useGetAPIIntegrations();

    const effectiveCategory =
        mappingCategory ?? SPECIAL_TABLE_CATEGORIES[table] ?? null;

    if (!effectiveCategory) return null;

    const matchingCategories = categories.filter(
        (c) => c.categoryTable === effectiveCategory,
    );
    if (matchingCategories.length === 0) return null;

    const activeCategory =
        matchingCategories.find((cat) =>
            integrations.some(
                (i) => i.software === cat.software.toUpperCase() && i.is_active,
            ),
        ) ?? matchingCategories[0];

    const labelKey =
        MAPPING_LABEL_KEYS[effectiveCategory] ?? 'dataCatalog.viewMappingTable';

    return {
        category: effectiveCategory,
        software: activeCategory.software,
        labelKey,
    };
};
